
namespace RioERP.Masters {
    export class InvoiceCompanyColumns {
        static columnsKey = 'Masters.InvoiceCompany';
    }
}